__turbopack_context__.v({
  "edgeLabel": "RangeSlider-module-scss-module__lIYkIq__edgeLabel",
  "fade-in": "RangeSlider-module-scss-module__lIYkIq__fade-in",
  "historgram": "RangeSlider-module-scss-module__lIYkIq__historgram",
  "interval": "RangeSlider-module-scss-module__lIYkIq__interval",
  "intervalInRange": "RangeSlider-module-scss-module__lIYkIq__intervalInRange",
  "no-transform": "RangeSlider-module-scss-module__lIYkIq__no-transform",
  "range": "RangeSlider-module-scss-module__lIYkIq__range",
  "rangeSlider": "RangeSlider-module-scss-module__lIYkIq__rangeSlider",
  "rangeTransparent": "RangeSlider-module-scss-module__lIYkIq__rangeTransparent",
  "root": "RangeSlider-module-scss-module__lIYkIq__root",
  "rotate": "RangeSlider-module-scss-module__lIYkIq__rotate",
  "sliderWrapper": "RangeSlider-module-scss-module__lIYkIq__sliderWrapper",
  "thumb": "RangeSlider-module-scss-module__lIYkIq__thumb",
  "track": "RangeSlider-module-scss-module__lIYkIq__track",
});
